import React from 'react'

function PoweredBy() {

    const images = [
        {
            id: "adobe",
            url: "/assets/images/Adobe.png" 
        },
        {
            id: "applepay",
            url: "/assets/images/applepay.png"
        },
       
        {
            id: "binance",
            url: "/assets/images/Binance.png"
        },
        {
            id: "coinStats",
            url: "/assets/images/CoinStats.png"
        },
        {
            id: "ethereum",
            url: "/assets/images/Ethereum.png"
        },
        {
            id: "github",
            url: "/assets/images/Github.png"
        },
        {
            id: "gmail",
            url: "/assets/images/Gmail.png"
        },
        {
            id: "google",
            url: "/assets/images/Google.png"
        },
        {
            id: "googleAnalitycs",
            url: "/assets/images/Google-Analytics.png"
        },
        {
            id: "gpay",
            url: "/assets/images/gpay.png"
        },
        {
            id: "mastercard",
            url: "/assets/images/Mastercard.png"
        },
        {
            id: "microsoft",
            url: "/assets/images/Microsoft.png"
        },
        {
            id: "visa",
            url: "/assets/images/visa.png"
        },
        {
            id: "openAi",
            url: "/assets/images/OpenAi.png"
        },
        {
            id: "gemini",
            url: "/assets/images/Gemini.png"
        },
    ]

  return (
    <div 
    
    className="flex flex-col justify-evenly items-center w-full h-screen relative z-100">
        <h1 className="text-slate-100 text-4xl lg:text-6xl font-bold tracking-wider">POWERED BY</h1>
        <div className="grid grid-cols-3 lg:grid-cols-5 grid-rows-auto items-center gap-4 p-2">
        {images.map(({id,url})=>(
            <img src={url} alt={`${id}_image`} key={id} className="rounded-lg bg-slate-600/60" />
        ))}
        </div>
    </div>
  )
}

export default PoweredBy